import { createContext } from 'react';
import { LoginData } from '../../model/LoginData';

export const LoginContext = createContext<LoginData | null>(null);
